import LegalPageLayout, { LegalSection } from "@/components/LegalPageLayout";
import { PHONE_DISPLAY, EMAIL } from "@/constants/business";

export default function CGVPage() {
  return (
    <LegalPageLayout
      title="Conditions générales de prestation"
      path="/conditions-generales"
      description="Conditions générales de prestation d'Express Delivery : devis, réservation, annulation, paiement."
      testId="cgv-page"
    >
      <LegalSection title="1. Objet">
        <p>
          Les présentes conditions encadrent les prestations de transport de biens, déménagement, manutention,
          groupage et transport longue distance réalisées par Express Delivery.
        </p>
      </LegalSection>
      <LegalSection title="2. Devis et validation">
        <p>
          Chaque prestation fait l'objet d'une proposition transmise avant intervention, précisant le tarif, le
          périmètre de la prestation et les conditions. La prestation est confirmée après validation de la
          proposition par le client.
        </p>
      </LegalSection>
      <LegalSection title="3. Réservation et annulation">
        <p>
          Le créneau d'intervention est organisé avec le client après validation. En cas d'empêchement, le client est
          invité à prévenir dès que possible afin de reprogrammer la prestation. Les conditions particulières
          applicables sont précisées dans chaque proposition avant validation.
        </p>
      </LegalSection>
      <LegalSection title="4. Tarif et modification de périmètre">
        <p>
          Le tarif est confirmé avant intervention. Si le volume réel ou les conditions d'accès diffèrent des
          informations transmises, le client est prévenu avant toute modification : aucun supplément n'est appliqué
          sans validation préalable.
        </p>
      </LegalSection>
      <LegalSection title="5. Paiement">
        <p>
          Les modalités de paiement (et l'éventuel acompte) sont précisées dans la proposition avant validation.
          Une facture peut être fournie. Les moyens de paiement acceptés sont indiqués dans la proposition et
          dans l'espace de suivi du dossier.
        </p>
      </LegalSection>
      <LegalSection title="6. Obligations du client">
        <p>
          Le client s'engage à fournir des informations exactes (adresses, étages, accès, liste des objets), à vider
          et débrancher les appareils électroménagers, et à signaler les objets fragiles ou de valeur.
        </p>
      </LegalSection>
      <LegalSection title="7. Protection des biens et responsabilité">
        <p>
          Les biens sont protégés par couvertures et sangles et le chargement est organisé avec soin. Les conditions
          de responsabilité et d'assurance applicables : [à compléter — références du contrat d'assurance
          professionnelle].
        </p>
      </LegalSection>
      <LegalSection title="8. Réclamations">
        <p>
          Toute réclamation peut être adressée par téléphone au {PHONE_DISPLAY} ou par email à {EMAIL}. Voir la page
          Réclamations pour la procédure détaillée.
        </p>
      </LegalSection>
      <p className="text-xs italic">
        Document en cours de finalisation : les champs signalés « à compléter » seront renseignés avec les
        informations juridiques définitives de l'entreprise.
      </p>
    </LegalPageLayout>
  );
}
